var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEmbed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.07611 13.4552C7.59236 13.6869 8.21576 13.4197 8.44745 12.9028L11.4572 5.92085C11.5644 5.67177 11.5644 5.3865 11.4753 5.11933C11.3682 4.85216 11.1727 4.65595 10.9229 4.54951C10.7983 4.49593 10.6557 4.46045 10.5131 4.46045C10.1033 4.46045 9.72966 4.70952 9.55154 5.08385L6.54176 12.0839C6.43462 12.333 6.43462 12.6183 6.52367 12.8855C6.63082 13.1345 6.82702 13.3307 7.07611 13.4553V13.4552Z",
    fill: "#C2C0CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3616 4.83474C14.1654 4.60305 13.8809 4.47852 13.5782 4.47852C13.3291 4.47852 13.0793 4.56757 12.9012 4.72759C12.6876 4.90571 12.5631 5.15478 12.545 5.44005C12.5269 5.72532 12.616 5.99249 12.7941 6.18799L15.1986 9.00238L12.7759 11.8168C12.4016 12.244 12.4552 12.9036 12.8831 13.2772C13.3102 13.6334 13.9872 13.5798 14.3435 13.17L17.3714 9.67933C17.7095 9.28762 17.7095 8.71779 17.3714 8.32537L14.3616 4.83474Z",
    fill: "#C2C0CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.11695 13.2772C5.54414 12.9028 5.59772 12.244 5.2241 11.8168L2.80138 9.00238L5.2241 6.18799C5.40222 5.97439 5.49127 5.70722 5.47318 5.44005C5.45509 5.15478 5.33055 4.90571 5.11695 4.72759C4.92074 4.56757 4.68976 4.47852 4.43997 4.47852C4.13732 4.47852 3.85205 4.60306 3.65655 4.83474L0.6286 8.32544C0.290467 8.71715 0.290467 9.28697 0.6286 9.67939L3.63838 13.1708C3.99461 13.5799 4.68967 13.6335 5.11688 13.2772L5.11695 13.2772Z",
    fill: "#C2C0CC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmbed);
export default __webpack_public_path__ + "static/media/iconEmbed.dacbd0e8.svg";
export { ForwardRef as ReactComponent };